import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/streams/streams-icon.svg'
import _imports_1 from '@/assets/streams/streams-text.svg'


const _withScopeId = n => (_pushScopeId("data-v-cd13287e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ad-unit-streams" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon-text",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_3 = { class: "latest-streams" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stream_card = _resolveComponent("stream-card")!
  const _component_common_section = _resolveComponent("common-section")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "streams-container",
      style: _normalizeStyle(_ctx.cssProps)
    }, [
      _hoisted_2,
      _createVNode(_component_stream_card, {
        class: "stream-card max-width",
        label: _ctx.t('streams.most-watched'),
        type: "highlighted",
        stream: _ctx.trendingStream
      }, null, 8, ["label", "stream"]),
      _createVNode(_component_common_section, {
        class: "c-section",
        colorLeft: _ctx.mainColor,
        colorRight: _ctx.secondaryColor,
        text: _ctx.t('streams.more-streams')
      }, null, 8, ["colorLeft", "colorRight", "text"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestStreams, (stream) => {
          return (_openBlock(), _createBlock(_component_stream_card, {
            key: stream.id,
            class: "stream-card-best-rated",
            type: "image",
            stream: stream
          }, null, 8, ["stream"]))
        }), 128))
      ]),
      (_ctx.pageReady)
        ? (_openBlock(), _createBlock(_component_layout_footer, {
            key: 0,
            spot: _ctx.adSpotFooter
          }, null, 8, ["spot"]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}